import React from "react";
import ProcessCard from "../Cards/ProcessCard";
import img1 from "../images/process-img-1.png";
import img2 from "../images/process-img-2.png";
import img3 from "../images/process-img-3.png";

export default function OurProcess() {
  const processes = [
    {
      img: img1,
      title: "Understanding/ Developing Strategy",
    },
    {
      img: img2,
      title: "Design & Website Development",
    },
    {
      img: img3,
      title: "Automated Testing & Support",
    },
  ];
  return (
    <div className="flex relative flex-col my-28 items-center justify-center text-center gap-24 h-full md:h-[70vh] w-full ">
      <p className=" text-center tracking-wider  font-semibold text-[50px] bg-clip-text text-transparent bg-gradient-to-r from-[#F9B5FB]  to-[#921196]">
        Our process
      </p>
   
      <div className="w-full flex flex-wrap md:flex-nowrap  gap-28 md:gap-0 justify-between items-center relative">
      {processes.map((data,index)=>(
        <ProcessCard title={data.title} img={data.img} key={index}/>
      ))}
    
      </div>
      <div className="block md:block">
      <div className=" absolute w-20 h-40 blur-[80px] right-8 top-20 bg-gradient-to-r rotate-90 from-[#006b8cdb] to-[#FF29C3]  "></div>
      <div className=" absolute w-20 h-40 blur-[80px] left-1 bottom-44 bg-gradient-to-r rotate-90 from-[#006b8cdb] to-[#FF29C3]  "></div>
      </div>
      </div>
  );
}
